import { useCallback, useEffect, useRef, useState } from "react";
import { premiumError } from "../../../services/Premium";

/** Jedna operacja naraz; zmiana zasobu unieważnia wynik poprzedniej operacji. */
export default function useAsyncAction(scope = null) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const running = useRef(null);
  const active = useRef(null);
  useEffect(() => {
    active.current = Symbol();
    running.current = null;
    setBusy(false);
    setError("");
    return () => {
      active.current = null;
    };
  }, [scope]);
  const run = useCallback(async (action) => {
    if (running.current) return;
    const operation = Symbol();
    const generation = active.current;
    const isActive = () => generation !== null && active.current === generation;
    running.current = operation;
    setBusy(true);
    setError("");
    try {
      return await action(isActive);
    } catch (error) {
      if (isActive()) setError(premiumError(error));
    } finally {
      if (running.current === operation) running.current = null;
      if (isActive()) setBusy(false);
    }
  }, []);
  return { busy, error, setError, run };
}
